import React from 'react';
import { FiCheck } from 'react-icons/fi';
import './suggest-store-shell.css';

export function SuggestStoreStepper({ steps, stepIndex }) {
  const stepNumber = stepIndex + 1;

  return (
    <div
      className="ss-stepper"
      role="progressbar"
      aria-valuemin={1}
      aria-valuemax={steps.length}
      aria-valuenow={stepNumber}
      aria-label={`Suggest a store step ${stepNumber} of ${steps.length}: ${steps[stepIndex]?.title}`}
    >
      {steps.map((step, index) => {
        const number = index + 1;
        const done = stepIndex > index;
        const current = stepIndex === index;
        const active = done || current;

        return (
          <div key={step.id} className="ss-stepper__item">
            <div className="ss-stepper__track">
              <div
                className={[
                  'ss-stepper__line',
                  'ss-stepper__line--left',
                  index === 0 ? 'ss-stepper__line--hidden' : '',
                  stepIndex >= index ? 'is-complete' : '',
                ]
                  .filter(Boolean)
                  .join(' ')}
              />
              <div
                className={[
                  'ss-stepper__circle',
                  active ? 'is-active' : '',
                  current ? 'is-current' : '',
                ]
                  .filter(Boolean)
                  .join(' ')}
              >
                {done ? (
                  <FiCheck aria-hidden="true" />
                ) : (
                  <span>{String(number).padStart(2, '0')}</span>
                )}
              </div>
              <div
                className={[
                  'ss-stepper__line',
                  'ss-stepper__line--right',
                  index === steps.length - 1 ? 'ss-stepper__line--hidden' : '',
                  stepIndex > index ? 'is-complete' : '',
                ]
                  .filter(Boolean)
                  .join(' ')}
              />
            </div>
            <div className={['ss-stepper__label', active ? 'is-active' : ''].join(' ')}>
              {step.title}
            </div>
          </div>
        );
      })}
    </div>
  );
}
